import { useEffect } from "react";
import { obtenerEstadosCivilesAction, obtenerGenerosAction } from "../../redux/datosPersonalesDucks";
import { obtenerNivelesEducacionalesAction } from "../../redux/datosEducacionalesDucks";
import FormDatosNacionalidadExtranjera from "./FormDatosNacionalidadExtranjera";
import { obtenerPaisesAction } from "../../redux/datosZonasDucks";
import { useSelector, useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import { HeadInput } from "../ui/HeadInput";
import PropTypes from "prop-types";

const FormDatosPersonales = ({ formik }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = () => {
      dispatch(obtenerGenerosAction());
      dispatch(obtenerEstadosCivilesAction());
      dispatch(obtenerPaisesAction());
      dispatch(obtenerNivelesEducacionalesAction());
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (formik.values.datosPersonales.nacionalidad === "1") {
      formik.setFieldValue("datosPersonaExtranjera.visaTemporariaDesde", "");
      formik.setFieldValue("datosPersonaExtranjera.visaTemporariaHasta", "");
      formik.setFieldValue("datosPersonaExtranjera.tipoVisa", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [formik.values.datosPersonales.nacionalidad]);
  const generos = useSelector(store => store.datosPersonales.generos);
  const estadosCiviles = useSelector(store => store.datosPersonales.estadosCiviles);
  const paises = useSelector(store => store.datosZonas.paises);
  const nivelesEducacionales = useSelector(store => store.datosEducacionales.nivelesEducacionales);
  const formatPais = pais => (pais.substring(0, 4) === "0000" ? pais.substring(8, pais.split("").length) : pais);

  return (
    <>
      <div className="row mt-3">
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Nombres *" formik={formik} html_for="nombres" datosObj="datosPersonales" />
          <input type="text" maxLength={35} name="datosPersonales.nombres" className="form-control" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPersonales.nombres} />
        </div>
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Apellido Paterno *" formik={formik} html_for="apellidoPaterno" datosObj="datosPersonales" />
          <input type="text" maxLength={20} name="datosPersonales.apellidoPaterno" className="form-control" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPersonales.apellidoPaterno} />
        </div>
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Apellido Materno" formik={formik} html_for="apellidoMaterno" datosObj="datosPersonales" />
          <input type="text" maxLength={20} name="datosPersonales.apellidoMaterno" className="form-control" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPersonales.apellidoMaterno} />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Fecha de nacimiento *" formik={formik} html_for="fechaNacimiento" datosObj="datosPersonales" />
          <input type="date" max="9999-12-31" name="datosPersonales.fechaNacimiento" className="form-control" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPersonales.fechaNacimiento} />
        </div>
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Género *" formik={formik} html_for="sexo" datosObj="datosPersonales" />
          <select className="form-select" name="datosPersonales.sexo" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPersonales.sexo}>
            <option value="">Seleccione</option>
            {generos && (
              <>
                {generos.map(genero => (
                  <option key={genero.id} value={genero.id}>
                    {genero.nombre}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Estado civil *" formik={formik} html_for="estadoCivil" datosObj="datosPersonales" />
          <select className="form-select" name="datosPersonales.estadoCivil" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPersonales.estadoCivil}>
            <option value="">Seleccione</option>
            {estadosCiviles && (
              <>
                {estadosCiviles.map(estadoCivil => (
                  <option key={estadoCivil.id} value={estadoCivil.id}>
                    {estadoCivil.nombre}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Nivel de formación" formik={formik} html_for="nivelFormacion" datosObj="datosPersonales" />
          <select className="form-select" name="datosPersonales.nivelFormacion" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPersonales.nivelFormacion}>
            <option value="">Seleccione</option>
            {nivelesEducacionales && (
              <>
                {nivelesEducacionales.map(nivel => (
                  <option key={nivel.id} value={nivel.id}>
                    {nivel.nombre}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Nacionalidad *" formik={formik} html_for="nacionalidad" datosObj="datosPersonales" />
          <select className="form-select" name="datosPersonales.nacionalidad" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPersonales.nacionalidad}>
            <option value="">Seleccione</option>
            {paises && (
              <>
                {paises.map(pais => (
                  <option key={pais.id} value={pais.id}>
                    {formatPais(pais.nombre)}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Email *" formik={formik} html_for="email" datosObj="datosPersonales" />
          <input
            autoComplete="off"
            type="email"
            name="datosPersonales.email"
            className="form-control"
            onChange={e => {
              formik.setFieldValue("datosPersonales.email", e.target.value.toLowerCase());
            }}
            onBlur={formik.handleBlur}
            value={formik.values.datosPersonales.email}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12 col-sm-4 my-1">
          <HeadInput label="Teléfono celular *" formik={formik} html_for="telefonoCelular" datosObj="datosPersonales" />
          <div className="input-group">
            <span className="input-group-text" id="inputGroup-sizing-default">
              {" "}
              +569{" "}
            </span>
            <NumberFormat name="datosPersonales.telefonoCelular" value={formik.values.datosPersonales.telefonoCelular} onValueChange={values => formik.setFieldValue("datosPersonales.telefonoCelular", values.value.replace(" ", ""))} style={{ paddingLeft: "10px" }} decimalSeparator={false} format="#### ####" allowNegative={false} className="form-control" onBlur={formik.handleBlur} />
          </div>
        </div>
      </div>
      {formik.values.datosPersonales.nacionalidad?.toString() !== "1" && formik.values.datosPersonales.nacionalidad?.toString() !== "" && <FormDatosNacionalidadExtranjera formik={formik} txtTipoVisa={formik.values.datosPersonaExtranjera.tipoVisa === "2" ? "Temporaria" : "Definitiva"} />}
    </>
  );
};

FormDatosPersonales.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default FormDatosPersonales;
